module.exports = __webpack_public_path__ + "static/img/user11.e8e8571.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user11.jpg
// module id = pCes
// module chunks = 23